<template>
  <div class="modal fade light " id="modalPromotion" ref="bank" tabindex="-1" aria-labelledby="exampleModalLabel"
    aria-hidden="true">
    <div class="modal-dialog modal-background modal-lg">
      <div class="modal-content">
        <div class=" ">
          <header class="modal-card-head">
            <p class="modal-card-title">ถอนเงิน</p><button aria-label="close" data-dismiss="modal"
              class="delete"></button>
          </header>
          <section class="modal-card-body">
            <div>
              <UpdateBonus></UpdateBonus>
            </div>
            <div style="height: 20px;">
            </div>
            <div data-v-2902d88e="" class="columns is-multiline is-centered">
              <div v-for="(item, i) in getPromotion" :key="i" data-v-2902d88e="" class="column"
                style="border:1px solid #cccccc; border-radius: 5px;">
                <div data-v-2902d88e="">
                  <img v-bind:src="item.ImageUrl" alt="promotion" class="card-img-top" />

                  <div data-v-2902d88e="">
                    <div data-v-2902d88e="" class="bonus-container blur">
                      <div data-v-2902d88e="" class="bonus-content">

                      </div>
                    </div>
                  </div>
                </div>

                <div class="card-text pt-2" style="">
                  <small class="d-block"> ข้อกำหนดและเงื่อนไข </small>
                  <!---->
                  <table style="width: 100%">
                    <tbody>
                      <tr class="tr-bor">
                        <td class="t-tt">ฝากขั้นต่ำ</td>
                        <td class="t-r">{{ item.minimumDeposit }}</td>
                        <td class="t-c">บาท</td>
                      </tr>
                      <tr class="tr-bor">
                        <td class="t-tt">ยอดวางเดิมพัน</td>
                        <td class="t-r">{{ item.TurnoverAmount }}</td>
                        <td class="t-c" v-text="item.DepositType == 1 ? 'เท่า' : 'บาท'"></td>
                      </tr>
                      <tr class="tr-bor">
                        <td class="t-tt">โบนัสสูงสุด</td>
                        <td class="t-r" v-text="
                          item.MaxBonus === 0
                            ? 'ไม่จำกัด'
                            : item.MaxBonus
                        "></td>
                        <td class="t-c" v-text="item.MaxBonusType == 1 ? 'เท่า' : 'บาท'"></td>
                      </tr>
                      <tr class="tr-bor">
                        <td class="t-tt">ถอนเงินสูงสุด</td>
                        <td class="t-r" v-text="
                          item.MaxWithdrawAmount === 0
                            ? 'ไม่จำกัด'
                            : item.MaxWithdrawAmount
                        "></td>
                        <td class="t-c" v-text="
  item.MaxWithdrawType == 1 ? 'เท่า' : 'บาท'
                        "></td>
                      </tr>
                    </tbody>
                  </table>

                </div>

              </div>

            </div>
          </section>
        </div>
      </div>
    </div>
  </div>


</template>
<script>
import { mapActions, mapGetters } from 'vuex'
import { UserInfoMixins } from '@/mixins/UserInfo.js'
import UpdateBonus from '@/components/form/UpdateBonus'

export default {
  name: 'PromotionForm',
  mixins: [UserInfoMixins],
  data() {
    return {
      isBonus: false,
    }
  },
  computed: {
    ...mapGetters([
      'getError',
      'getLoading',
      'getLineId',
      'getGameList',
      'getPromotion',
      'getPrefix',
    ]),
  },
  components: {
    UpdateBonus,
  },
  methods: {},
}
</script>
<style scoped>
.form-check-input[type=checkbox] {
  width: 1em;
  border-radius: 0.25em;
}

.form-check-input[type=radio] {
  width: 1em;
  border-radius: 0.25em;
}
</style>



// WEBPACK FOOTER //
// src/components/form/PromotionForm.vue